import { FC } from 'react';
import { ContentLoader } from '@edikk-edikk/country-common';
import { useProcessApiError } from '@edikk-edikk/hooks';
import { Container, ContainerWidth } from '#components/container';
import authPageCss from '#user/assets/auth-page.module.scss';
import { ForgotPasswordForm, MetaData } from '#userForgotPasswod/components';
import { useApi } from '#hooks/use-api';

const ForgotPassword: FC = () => {
  const api = useApi();
  const { isLoading, isError, error } = api.getApiUserForgotPassword().useInitQuery();
  useProcessApiError(error);

  if (isLoading) {
    return <ContentLoader />;
  }

  if (isError) {
    return null;
  }

  return (
    <Container withMarginTopXs width={ContainerWidth.sm} additionalClassName={authPageCss.authPage}>
      <MetaData />
      <ForgotPasswordForm />
    </Container>
  );
};

export { ForgotPassword };
